import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../environments/environment';

const HOST = environment.serverUrl;
const DIAGNOSTICS_API_URL = HOST + '/diagnostics';

export enum DiagnosticStatus {
  REQUESTED = 'REQUESTED',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  UPLOADED = 'UPLOADED',
  ERROR = 'ERROR'
}

export interface Diagnostic {
  id: string;
  type: string;
  chargepointId: string;
  location: string;
  createdAt: Date;
  uploadedAt?: Date;
  status: DiagnosticStatus;
  filename: string;
  contentType: string;
}

export interface DiagnosticSearchCriteria {
  chargepointId?: string;
}

function reviveDiagnostic(diagnostic: Diagnostic): Diagnostic {
  diagnostic.createdAt = diagnostic.createdAt ? new Date(diagnostic.createdAt) : new Date(0);
  diagnostic.uploadedAt = diagnostic.uploadedAt ? new Date(diagnostic.uploadedAt) : undefined;
  return diagnostic;
}

@Injectable({ providedIn: 'root' })
export class DiagnosticsApiService {

  constructor(private http: HttpClient) { }

  public searchDiagnostics(searchCriteria: DiagnosticSearchCriteria): Observable<Diagnostic[]> {
    return this.http.post<Diagnostic[]>(`${DIAGNOSTICS_API_URL}/search`, {...searchCriteria}, { responseType: 'json' })
      .pipe(
        map(diagnostics => diagnostics.map(reviveDiagnostic))
      );
  }

  public downloadDiagnostic(id: string): Observable<ArrayBuffer> {
    return this.http.get<ArrayBuffer>(`${DIAGNOSTICS_API_URL}/${id}/download`);
  }
}
